var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import './tooltip.module.css';
import clsx from 'clsx';
import styles from './tooltip.module.css';
export var Tooltip = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.show, show = _d === void 0 ? true : _d, _e = _a.type, type = _e === void 0 ? 'info' : _e, _f = _a.position, position = _f === void 0 ? 'topRight' : _f, props = __rest(_a, ["text", "size", "show", "type", "position"]);
    return (_jsx("div", __assign({ "data-tooltip": text, className: clsx(styles.tooltip, styles["tooltip__".concat(type)], styles["tooltip__".concat(position)]) }, props, { children: _jsx("div", __assign({ className: "s-tooltip__wrapper" }, { children: _jsx("div", { className: "s-tooltip__body" }) })) })));
};
export default Tooltip;
